import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21989dd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-upper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "buttons" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "PROTOTYP")
  ])
], -1))
const _hoisted_3 = { id: "buttons" }
const _hoisted_4 = { class: "user" }
const _hoisted_5 = { style: {"display":"flex","flex-wrap":"nowrap","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "material-icons",
  style: {"padding-right":"0.2em"}
}, " account_circle ", -1))
const _hoisted_7 = { class: "links" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("LEIs Registrieren")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Suche")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Mitarbeiter")
const _hoisted_12 = { class: "container-lower" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appIcon" }, [
  /*#__PURE__*/_createTextVNode(" ⁞⁞⁞⁞ "),
  /*#__PURE__*/_createElementVNode("span", null, "WM"),
  /*#__PURE__*/_createTextVNode(" LEIPORTAL ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "material-icons",
  style: {"padding":"0.4em","font-size":"0.8em"}
}, " shopping_cart ", -1))
const _hoisted_15 = { style: {"display":"inline-block","font-size":"0.8em","vertical-align":"top","margin-top":"0.2em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: _ctx.accountPath,
            class: _normalizeClass(_ctx.accountClass)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.accountText), 1)
              ])
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/request",
            class: _normalizeClass(_ctx.$route.path === '/request' ? 'active' : undefined)
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: _normalizeClass(_ctx.$route.path === '/dashboard' ? 'active' : undefined)
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/search",
            class: _normalizeClass(_ctx.$route.path === '/search' ? 'active' : undefined)
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: '/employee',
            class: _normalizeClass([_ctx.$route.path === '/employee' ? 'active' : undefined, "private-link"])
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("button", {
        class: "cart",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/cart')))
      }, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.items.length), 1)
      ])
    ])
  ], 64))
}